module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "more"
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('h3', {
    staticClass: "section-header sites"
  }, [_vm._v("链接")]), _vm._v(" "), _c('div', {
    staticClass: "section-content"
  }, [_c('ul', {
    staticClass: "links"
  }, _vm._l((_vm.sites), function(site) {
    return _c('li', {
      key: site.id
    }, [_c('a', {
      attrs: {
        "href": site.href,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "url-pic"
    }, [_c('img', {
      attrs: {
        "width": "100%",
        "height": "100%",
        "src": site.logo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "url-info"
    }, [_vm._v(_vm._s(site.title))])])])])
  }), 0)])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('h3', {
    staticClass: "section-header qq-wechat-weibo"
  }, [_vm._v("QQ/微信/微博")]), _vm._v(" "), _c('div', {
    staticClass: "section-content"
  }, [_c('p', [_c('i', {
    staticClass: "iconfont icon-unie61d text-red"
  }), _vm._v("新浪微博"), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("坂井泉水_ZARD")])]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "iconfont icon-qq text-blue"
  }), _vm._v("QQ群Soffio~Taste ZARD 群号:65367929")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-xs-6 qr"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/wechat.png")
    }
  })]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "iconfont icon-weixin text-green"
  }), _vm._v("微信公众号ZARD")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 qr"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/qq.png")
    }
  })]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "iconfont icon-qq text-blue"
  }), _vm._v("QQ部落ZARD")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a90d9e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/More.vue
// module id = 103
// module chunks = 0